import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiDialog: MuiComponent<"MuiDialog"> = {
  styleOverrides: {
    paper: {
      borderRadius: 12,
      border: `1px solid ${Colors.BorderGray}`
    },
    container: {
      backdropFilter: 'blur(4px)',
    }
  },
};